import { BarSeries as BarSeriesDefinition } from "lightweight-charts";
import merge from "lodash/merge";
import { BarData, BarSeriesOptions } from "../chart.typings";
import BaseChartSeries from "./baseSeries";
import { barSeriesOptions } from "../../../assets/constants";

class BarSeries extends BaseChartSeries<BarData, BarSeriesOptions> {

    addSeriesToChart() {
        return this.createSeries(BarSeriesDefinition, this.seriesOptions)
    }

    getDefaultOptions(): BarSeriesOptions {
        return merge(barSeriesOptions, this.options)
    }

}

export default BarSeries;